$('.ruleConfirmInput, .privacyPolicyConfirmInput').change(function(){
    if($('.ruleConfirmInput').is(':checked') && $('.privacyPolicyConfirmInput').is(':checked')) {
        $(this).closest('.modal-body').find('button.btn').removeClass('disabled');
    } else {
        $(this).closest('.modal-body').find('button.btn').addClass('disabled');
    }
});

$('.js-btn-scl, #sclModalRegOldPromo .modal-body button.btn').not('.disabled').click(function(e){
    var name = $(e.target).data('name');
    var targetId = $(e.target).closest('.modal').attr('id');

    if (targetId === 'sclModal') {
        if($(e.target).hasClass('disabled')) {
            alert('Need confirm RULE');
            return false;
        }
    }

    isLoginBtn = (targetId === 'loginModal');
    type = name;
    var redirectUrl = window.location.href;

    switch (name) {
        case 'instagram':
            OAuth.redirect('instagram', redirectUrl);
            break;
        case 'facebook':
            OAuth.redirect('facebook', redirectUrl);
            break;
        case 'vk':
            OAuth.redirect('vk', redirectUrl);
            break;
        case 'google':
            OAuth.redirect('google', redirectUrl);
            break;
    }
});

var isLoginBtn;
var accessToken, numFriends = 0, socialId, socialLink, sex, firstName, lastName, birthday, email, type;

var socialAuth = {
    init: function(){
        OAuth.initialize(SOCIALS.OAUTH.KEY);
        OAuth.setOAuthdURL(SOCIALS.OAUTH.URL);
        $('#sclModal .modal-body button.btn, #sclModalRegOldPromo .modal-body button.btn').addClass('disabled');
        $('.js-open-registration').on('click', function(){
            $('.js-btn-registration').hide();
            $('.js-social-registration').show();
        });

        if (OAuth.callback('facebook') !== undefined) {
            OAuth.callback('facebook')
                .done(function (result) {
                    type = 'fb';
                    accessToken = result.access_token;
                    result.me().done(function (data) {
                        email = data.email;
                        socialId = data.id;
                        firstName = data.firstname;
                        lastName = data.lastname;

                        socialAuth.registration({
                            accessToken: accessToken,
                            numFriends: numFriends,
                            socialId: socialId,
                            socialLink: socialLink,
                            sex: sex,
                            firstName: firstName,
                            lastName: lastName,
                            birthday: birthday,
                            email: email,
                            type: type,
                            isLogin: isLoginBtn
                        });
                    });
                })
                .fail(function (err) {
                    console.log(err);
                });
        }

        if (OAuth.callback('instagram') !== undefined) {
            OAuth.callback('instagram')
                .done(function (result) {
                    type = 'inst';
                    accessToken = result.access_token;
                    socialLink = 'https://www.instagram.com/' + result.user.username;
                    socialId = result.user.id;
                    firstName = result.user.full_name;

                    socialAuth.registration({
                        accessToken: accessToken, numFriends: numFriends, socialId: socialId,
                        socialLink: socialLink, sex: sex, firstName: firstName, lastName: lastName, birthday: birthday,
                        email: email, type: type, isLogin: isLoginBtn
                    });
                })
                .fail(function (err) {
                    console.log(err);
                });
        }

        if (OAuth.callback('vk') !== undefined) {
            OAuth.callback('vk')
                .done(function (result) {
                    type = 'vk';
                    accessToken = result.access_token;
                    result.me().done(function (data) {
                        socialId = data.id;
                        firstName = data.firstname;
                        lastName = data.lastname;
                        socialLink = data.url;
                        birthday = data.birthdate.day + '.' + data.birthdate.month + '.' + data.birthdate.year;
                        sex = data.gender;

                        var fields = 'counters,domain';
                        var url = 'https://api.vk.com/method/users.get?user_id=' + socialId + '&fields=' + fields + '&v=5.131';

                        result.get(url).done(function (data) {
                            numFriends = data['response'][0]['counters']['friends'];
                            socialLink = 'https://vk.com/' + data['response'][0]['domain'];

                            socialAuth.registration({
                                accessToken: accessToken,
                                numFriends: numFriends,
                                socialId: socialId,
                                socialLink: socialLink,
                                sex: sex,
                                firstName: firstName,
                                lastName: lastName,
                                birthday: birthday,
                                email: email,
                                type: type,
                                isLogin: isLoginBtn
                            });
                        });
                    });
                })
                .fail(function (err) {
                    console.log(err);
                });
        }

        if (OAuth.callback('google') !== undefined) {
            OAuth.callback('google')
                .done(function (result) {
                    type = 'yt';
                    accessToken = result.access_token;
                    socialId = result.user.id;
                    firstName = result.user.first_name;
                    lastName = result.user.last_name;
                    email = result.user.email;
                    var youtubeAcountUrl = "https://www.googleapis.com/youtube/v3/channels?part=snippet%2CcontentDetails%2CbrandingSettings&mine=true&key=" + SOCIALS.GOOGLE.APIKEY + "&access_token=" + accessToken;
                    result.get(youtubeAcountUrl).done(function (data) {
                        var channel = data.items && data.items[0];
                        if (channel) {
                            socialId = channel.id;
                        }
                        socialLink = "https://youtube.com/channel/" + socialId;
                        var youtubeStatisticUrl = "https://www.googleapis.com/youtube/v3/channels?part=statistics&id=" + socialId + "&key=" + SOCIALS.GOOGLE.APIKEY + "&access_token=" + accessToken;

                        result.get(youtubeStatisticUrl).done(function (response) {
                            response.json()
                                .then(function (data) {
                                    numFriends = data.items && data.items[0] && data.items[0].statistics && data.items[0].statistics.subscriberCount;

                                    socialAuth.registration({
                                        accessToken: accessToken,
                                        numFriends: numFriends,
                                        socialId: socialId,
                                        socialLink: socialLink,
                                        sex: sex,
                                        firstName: firstName,
                                        lastName: lastName,
                                        birthday: birthday,
                                        email: email,
                                        type: type,
                                        isLogin: isLoginBtn
                                    });
                                });
                        });
                    });
                })
                .fail(function (err) {
                    console.log(err);
                });
        }
    },
    registration: function(args){
        $.post(URL.REGISTRATION, args, function(response){
            if (response.success == false && response.redirectToReg) {
                mainController.hideModal($('#loginModal'));
                mainController.showModal($('#sclModal'));
                $(".js-btn-registration").on("click", function() {
                    args.isLogin = false;
                    socialAuth.registration(args);
                });
            } else {
                if (response.isNewUser == true) {
                    dataLayer.push({'event': 'registration', 'regNewUser': 'regNewUser'});
                    if ($('#sclModalRegOldPromo').is(":visible")) {
                        dataLayer.push({'event': 'registration', 'regNewUser': 'regNewUserOldPromotions'});
                    }
                } else {
                    dataLayer.push({'event': 'auth', 'authUser': 'authUser'});
                }

                URL_CONST.LOGIN_REDIRECT = URL_CONST.LOGIN_REDIRECT.replace(/#.*/g,'');
                window.location.href = URL_CONST.LOGIN_REDIRECT;
            }
        });
    }
};

$(function(){
    socialAuth.init();
});
